<style lang="scss" scoped></style>

<template lang="pug">
    el-switch(v-model="user.enable_2fa", @change="handleChange" active-color="#4c85ff", inactive-color="#ff4949", active-value=true, inactive-value=false, active-text="Activate two-factor authentication (recommended)")
</template>

<script>
import gql from "graphql-tag";
import ConfirmDeletion from "@/components/modals/ConfirmDeletion";
import EnableTwoFactorModal from "@/components/modals/EnableTwoFactorModal";

export default {
	name: "EditCompanyScopes",
	components: { EnableTwoFactorModal, ConfirmDeletion },
	props: {
		user: {
			type: Object,
			required: true
		}
	},
	data: () => ({
		enabled: false
	}),
	methods: {
		handleChange(enabled) {
			enabled ? this.showEnableModal() : this.showDisableModal();
		},
		showEnableModal() {
			this.$vuedals.open({
				component: EnableTwoFactorModal,
				title: "Enable Two Factor Authentication",
				props: {
					user: this.user
				},
				onClose: () => {
					this.$emit("options:updated");
				},
				onDismiss: () => {
					this.$emit("options:updated");
				}
			});
		},
		showDisableModal() {
			this.$vuedals.open({
				component: ConfirmDeletion,
				title: "Disable Two Factor Authentication",
				props: {
					value: "DISABLE"
				},
				onClose: async confirm => {
					if (confirm) {
						try {
							await this.$apollo.mutate({
								mutation: gql`
									mutation SaveUser($input: SaveUserInput!) {
										SaveUser(input: $input) {
											id
										}
									}
								`,
								variables: {
									input: { enable_2fa: false, secret_2fa: null }
								}
							});
							this.$message.success("Two Factor Authenticated is now disabled");
						} catch (error) {
							console.log("error", error);

							this.$message.error("Error: Could not disable Two Factor Authentication");
						}

						this.$emit("options:updated");
					}
				},
				onDismiss: () => {
					this.$emit("options:updated");
				}
			});
		}
	}
};
</script>
